// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.state_navigation_button_widget_container{
    height: 100%;
    display: grid;
    align-items: center;
}
.state_navigation_button_widget_container .image-container{
    width: 100%;
    height: 100%;
    padding: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.state_navigation_button_widget_container img{
    max-height: 100px;
}
.state_navigation_button_widget_container p{
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/Buttons/StateNavigationButtonWidget.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".state_navigation_button_widget_container{\n    height: 100%;\n    display: grid;\n    align-items: center;\n}\n.state_navigation_button_widget_container .image-container{\n    width: 100%;\n    height: 100%;\n    padding: 5%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n}\n.state_navigation_button_widget_container img{\n    max-height: 100px;\n}\n.state_navigation_button_widget_container p{\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
